/* Wide nav dropdowns: hover intent (snippets/fj-mega-menu.liquid, Jenny
   2026-10-08: "when I hover towards the actual dropdown, it doesn't glitch
   or fade out").

   Dawn's header-menu opens on mouseenter and shuts on mouseleave, at once.
   With panels this wide that misfired three ways: the pointer heading
   diagonally from SHOP ALL to its photos crossed HANDMADE and swapped the
   panel; a one-frame slip outside shut it; and a swap faded one panel out
   while the next faded in. So for these items:

   - Opening waits 80ms (a pass across the bar opens nothing).
   - Switching to another item needs the pointer to rest on it for 160ms,
     so a diagonal crossing keeps the panel it is heading for.
   - Leaving waits 260ms before closing, and coming back cancels it.
   - All four menus share ONE white sheet (.fj-mega-sheet). Its height,
     --fj-sheet-h on <sticky-header>, is set here to the open panel's
     height, so the sheet grows out of the header, morphs between menus of
     different sizes and rolls back up on close (the motion is in the CSS).

   While any sheet is open, one shared dim covers the page below the header
   (.fj-mega-dim, the site's usual warm 30% + blur). It hangs from the
   header's bottom edge in CSS, so it follows the bar as it changes height
   or slides in.

   The <details> open state is kept in step, so the keyboard (Enter on the
   item), Dawn's "keep the header while a menu is open" and aria all work as
   before. The look of open / closed is in assets/fj-mega-menu.css
   (.fj-mega-item.is-open). */
(function () {
  var OPEN_DELAY = 80;
  var SWITCH_DELAY = 160;
  var CLOSE_DELAY = 260;
  /* How long a closing panel stays in an open <details> so its fade can
     play: the browser stops drawing a closed <details>' content at once,
     which made the old menu vanish instead of fading. Just over the CSS
     fade-out (visibility flips at 720ms on a full close). */
  var FADE_OUT = 760;

  function start() {
    var nav = document.querySelector('.header__inline-menu');
    var items = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu li.fj-mega-item'));
    if (!nav || !items.length) return;

    var current = null;
    var openTimer;
    var closeTimer;

    var bar = nav.closest('sticky-header');
    var dim = document.createElement('div');
    dim.className = 'fj-mega-dim';
    dim.setAttribute('aria-hidden', 'true');
    var sheet = document.createElement('div');
    sheet.className = 'fj-mega-sheet';
    sheet.setAttribute('aria-hidden', 'true');
    /* First in the header, in this order (dim, then sheet), so the panels,
       later and also positioned, paint over both. */
    if (bar) {
      bar.prepend(sheet);
      bar.prepend(dim);
    }

    /* The open panel can still be settling when it is first measured (a
       first open of Collectibles read 312px of its 351), which cut the
       sheet short under the captions. Follow its real size instead. */
    if (window.ResizeObserver) {
      var watcher = new ResizeObserver(function (entries) {
        if (!current) return;
        for (var i = 0; i < entries.length; i++) {
          if (current.contains(entries[i].target)) {
            sizeSheet();
            return;
          }
        }
      });
      items.forEach(function (li) {
        watcher.observe(li.querySelector('.fj-mega'));
      });
    }

    function sizeSheet() {
      if (!bar) return;
      var h = current ? current.querySelector('.fj-mega').offsetHeight : 0;
      bar.style.setProperty('--fj-sheet-h', h + 'px');
      bar.classList.toggle('fj-mega-on', !!current);
    }

    /* The dim hangs from the header's bottom edge in CSS (fj-mega-menu.css),
       so it follows the bar wherever it is; nothing to measure here. */
    function dimOn(on) {
      dim.classList.toggle('is-on', on);
    }

    var placing = false;
    /* The line lives in the header, so scrolling never moves it; only the
       header changing size (full bar to slim bar) does. Then it jumps to
       the word's new spot with no glide. */
    var lastBarH = 0;
    function placeSoon() {
      if (lineShown && bar && bar.offsetHeight !== lastBarH) requestAnimationFrame(function () {
        line.classList.add('is-parking');
        updateLine();
        void line.offsetWidth;
        line.classList.remove('is-parking');
      });
      if (bar) lastBarH = bar.offsetHeight;
      if (!current || placing) return;
      placing = true;
      requestAnimationFrame(function () {
        placing = false;
        sizeSheet();
        checkPointer();
      });
    }
    window.addEventListener('scroll', placeSoon, { passive: true });

    /* Scrolling means she has moved on: start the soft close as soon as the
       page has moved a little, instead of letting the open menu ride off
       the top of the screen with the header first (Jenny 2026-10-08, "when
       I start scrolling down... the fade out is pretty drastic"). */
    var openScroll = 0;
    window.addEventListener('scroll', function () {
      if (current && Math.abs(window.scrollY - openScroll) > 24) {
        clearTimeout(closeTimer);
        closeTimer = null;
        clearTimeout(openTimer);
        hide();
      }
    }, { passive: true });
    window.addEventListener('resize', placeSoon);

    function detailsOf(li) {
      return li.querySelector('details');
    }

    var shutTimers = new Map();
    function shutLater(li) {
      clearTimeout(shutTimers.get(li));
      shutTimers.set(li, setTimeout(function () {
        shutTimers.delete(li);
        if (li !== current) detailsOf(li).open = false;
      }, FADE_OUT));
    }

    /* Which way the content moves (assets/fj-mega-menu.css reads these):
       opening from nothing rises 8px; a switch slides the new menu in
       from the side the pointer moved toward, the old one drifts out the
       other way; a close just fades. */
    function setMotion(inX, inY, outX) {
      if (!bar) return;
      bar.style.setProperty('--fj-in-x', inX);
      bar.style.setProperty('--fj-in-y', inY);
      bar.style.setProperty('--fj-out-x', outX);
    }

    /* Dawn's HeaderMenu sets bar.preventHide from each <details>' toggle, so
       the old menu finishing its close after a switch said "nothing open"
       and the next scroll slid the header (and the open menu) away: the
       "collapses on me while I'm browsing" (Jenny 2026-10-08). Our toggle
       listener puts it back a tick after Dawn's; show and hide keep it. */
    function holdBar() {
      if (bar) bar.preventHide = !!current;
    }

    /* Has the pointer really left? Anywhere in the open menu's full outline
       counts as inside, from the bottom of its nav word down: while the
       sheet is still growing into a taller menu, the bottom of the panel is
       clipped and cannot be hovered, so a resting pointer there used to
       "leave" and close it. Any nav item with a wide menu counts too, so
       moving to another one switches instead of closing. */
    function insideAt(x, y, target) {
      if (!current) return true;
      if (target && target.closest) {
        if (target.closest('li.fj-mega-item')) return true;
        /* A top item with no wide menu (NEW): moving onto it closes. */
        if (target.closest('.list-menu--inline > li')) return false;
      }
      var panel = current.querySelector('.fj-mega').getBoundingClientRect();
      var word = current.querySelector('summary').getBoundingClientRect();
      var row = nav.getBoundingClientRect();
      /* Under the nav word: the whole width of the sheet. On the nav row
         itself: only along the nav links, so heading for the logo or the
         icons still closes it. */
      if (y >= word.bottom) return x >= panel.left && x <= panel.right && y <= panel.bottom;
      return y >= word.top && x >= row.left && x <= row.right;
    }

    var pointer = null;
    function checkPointer() {
      if (!current || !pointer) return;
      if (insideAt(pointer.x, pointer.y, document.elementFromPoint(pointer.x, pointer.y))) {
        clearTimeout(closeTimer);
        closeTimer = null;
      } else if (!closeTimer) {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeTimer = null;
          hide();
        }, CLOSE_DELAY);
      }
    }

    document.addEventListener('pointermove', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      pointer = { x: event.clientX, y: event.clientY };
      checkPointer();
    }, { passive: true });

    /* The pointer leaving the window altogether. */
    document.documentElement.addEventListener('mouseleave', function () {
      if (!current) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeTimer = null;
        hide();
      }, CLOSE_DELAY);
    });

    /* --- The nav underline glides between items (Jenny 2026-10-08: "move
       in the direction of how the user browses... the line will ease into
       Collectibles"). One line for the whole bar instead of one per item:
       the first time it appears it draws in from the left under the word;
       moving to another item slides it across, stretching or shrinking to
       the new word; leaving the bar fades it, and the next visit draws in
       from the left again. While a wide menu is open it sits under THAT
       item, so it moves exactly when the menu switches. The per-item lines
       in custom.css stand down once this runs (.fj-nav-glide). */
    var line = document.createElement('span');
    line.className = 'fj-nav-line';
    line.setAttribute('aria-hidden', 'true');
    if (bar) bar.appendChild(line);
    nav.classList.add('fj-nav-glide');

    var topItems = Array.prototype.slice.call(nav.querySelectorAll('.list-menu--inline > li'));
    var hovered = null;
    var focused = null;
    var lineShown = false;
    var lineFrame = 0;

    function wordOf(li) {
      return li.querySelector(':scope > .header__menu-item, :scope > header-menu > details > .header__menu-item');
    }

    function lineTarget() {
      if (current) return current;
      return hovered || focused;
    }

    function updateLine() {
      if (!bar) return;
      var li = lineTarget();
      var word = li && wordOf(li);
      var box = word && word.getBoundingClientRect();
      if (!box || !box.width) {
        if (lineShown) {
          line.classList.remove('is-on');
          lineShown = false;
        }
        return;
      }
      var origin = bar.getBoundingClientRect();
      /* A dropdown item carries 8px of slack after its chevron. */
      var slack = word.tagName === 'SUMMARY' ? 8 : 0;
      var x = box.left - origin.left;
      var y = box.bottom - origin.top + 4;
      var w = box.width - slack;
      if (!lineShown) {
        /* Park it at the word's left edge with no width and no motion,
           then grow it on the next frame: it draws in from the left. */
        line.classList.add('is-parking');
        line.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        line.style.width = '0px';
        void line.offsetWidth;
        line.classList.remove('is-parking');
        lineShown = true;
        cancelAnimationFrame(lineFrame);
        lineFrame = requestAnimationFrame(function () {
          line.classList.add('is-on');
          line.style.width = w + 'px';
        });
        return;
      }
      line.classList.add('is-on');
      line.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      line.style.width = w + 'px';
    }

    topItems.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        hovered = li;
        updateLine();
      });
      li.addEventListener('mouseleave', function () {
        if (hovered === li) hovered = null;
        updateLine();
      });
      li.addEventListener('focusin', function (event) {
        var word = wordOf(li);
        if (word && word.contains(event.target) && event.target.matches(':focus-visible')) {
          focused = li;
          updateLine();
        }
      });
      li.addEventListener('focusout', function () {
        if (focused === li) focused = null;
        requestAnimationFrame(updateLine);
      });
    });

    function show(li) {
      if (current === li) return;
      clearTimeout(shutTimers.get(li));
      if (current) {
        var dir = items.indexOf(li) > items.indexOf(current) ? 1 : -1;
        setMotion(dir * 2.4 + 'rem', '0rem', dir * -2.4 + 'rem');
        current.classList.remove('is-open');
        shutLater(current);
      } else {
        setMotion('0rem', '0.8rem', '0rem');
        openScroll = window.scrollY;
      }
      current = li;
      li.classList.add('is-open');
      detailsOf(li).open = true;
      dimOn(true);
      sizeSheet();
      holdBar();
      updateLine();
    }

    function hide() {
      if (!current) return;
      setMotion('0rem', '0.8rem', '0rem');
      current.classList.remove('is-open');
      shutLater(current);
      current = null;
      dimOn(false);
      sizeSheet();
      holdBar();
      updateLine();
    }

    items.forEach(function (li) {
      var menu = li.querySelector('header-menu');
      /* Silence Dawn's instant hover handlers on these items only. Capture
         listeners at the target run first, so stopping here keeps theirs
         from firing. */
      ['mouseenter', 'mouseleave'].forEach(function (type) {
        menu.addEventListener(type, function (event) {
          event.stopImmediatePropagation();
        }, true);
      });

      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeTimer = null;
        clearTimeout(openTimer);
        if (current === li) return;
        openTimer = setTimeout(function () {
          show(li);
        }, current ? SWITCH_DELAY : OPEN_DELAY);
      });

      /* Leaving the item only cancels a pending open; whether the menu
         closes is decided by the pointer's position (checkPointer). */
      li.addEventListener('mouseleave', function (event) {
        if (current !== li) clearTimeout(openTimer);
        pointer = { x: event.clientX, y: event.clientY };
        checkPointer();
      });

      /* Keyboard, a tap, or Dawn closing it (Escape, focus leaving). */
      detailsOf(li).addEventListener('toggle', function () {
        var open = detailsOf(li).open;
        if (open && current !== li) show(li);
        else if (!open && current === li) {
          li.classList.remove('is-open');
          current = null;
          dimOn(false);
          sizeSheet();
          updateLine();
        }
        /* A tick later: Dawn's own toggle handler may run after this one
           (its script can load later), and it must not have the last word. */
        setTimeout(holdBar, 0);
      });
    });
  }

  /* Menu photos load AHEAD of the first hover (Jenny 2026-10-16: "a delay
     in the pictures loading" when she moved to the menu). They are lazy, and
     a closed menu counts as off screen, so they used to start downloading
     only once a menu opened. Now, once the page itself has finished loading
     and the browser is idle, they are fetched and decoded in the background;
     moving the pointer onto the nav bar fetches them at once if that has not
     happened yet. Only where the wide menus exist (a mouse, 990px and up),
     so phones never spend data on them. */
  function warmPhotos() {
    if (warmPhotos.done) return;
    warmPhotos.done = true;
    document.querySelectorAll('.fj-mega__img').forEach(function (img) {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    });
  }

  function setUpWarmUp() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var later = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
    var onLoad = function () { later(warmPhotos, { timeout: 2000 }); };
    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad, { once: true });
    var bar = document.querySelector('.header__inline-menu');
    if (bar) bar.addEventListener('pointerenter', warmPhotos, { once: true });
  }

  function boot() {
    start();
    setUpWarmUp();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
